const topicItems = [
  { name: '国产悬疑剧', count: '128万讨论', icon: 'ri-search-eye-line', hot: true },
  { name: '漫威宇宙', count: '96万讨论', icon: 'ri-planet-line', hot: true },
  { name: '宫崎骏动画', count: '85万讨论', icon: 'ri-landscape-line', hot: false },
  { name: '韩剧推荐', count: '231万讨论', icon: 'ri-heart-pulse-line', hot: true },
  { name: '经典港片', count: '67万讨论', icon: 'ri-vidicon-line', hot: false },
  { name: '科幻电影', count: '112万讨论', icon: 'ri-rocket-line', hot: true },
  { name: '纪录片推荐', count: '54万讨论', icon: 'ri-camera-lens-line', hot: false },
  { name: '日漫新番', count: '189万讨论', icon: 'ri-ghost-line', hot: true },
  { name: '综艺搞笑名场面', count: '156万讨论', icon: 'ri-emotion-happy-line', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-500/10 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-hashtag text-xs"></i>
            话题广场
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-2">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm">全网影视爱好者都在讨论什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item, idx) => (
            <div
              key={idx}
              className="group inline-flex items-center gap-2 px-4 py-3 rounded-xl bg-background-100 border border-background-300/40 hover:border-primary-500/40 transition-all cursor-pointer"
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg ${
                  item.hot
                    ? 'bg-accent-500/15 text-accent-400'
                    : 'bg-background-300/50 text-foreground-500'
                }`}
              >
                <i className={`${item.icon} text-sm`}></i>
              </div>
              <div>
                <div className="flex items-center gap-1.5">
                  <span className="text-sm font-medium text-foreground-200 whitespace-nowrap">
                    #{item.name}
                  </span>
                  {item.hot && (
                    <span className="inline-flex items-center gap-0.5 text-accent-400">
                      <i className="ri-fire-fill text-xs"></i>
                    </span>
                  )}
                </div>
                <span className="text-foreground-600 text-xs">{item.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}